import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Table from "material-ui/Table";
import TBody from "material-ui/Table/TableBody";
import Thead from "material-ui/Table/TableHead";
import Tc from "material-ui/Table/TableCell";
import Tr from "material-ui/Table/TableRow";
import Paper from "material-ui/Paper";
import toFixed from "utils/toFixed";

const styleProsTable = {
  head: {
    backgroundColor: "#3F51B5",
    opacity: 1.79,
    color: "#E8EAF6",
    fontWeight: "bold",
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center"
  },
  odd: {
    backgroundColor: "#C5CAE9",
    opacity: 1.79,
    height: 80
  },
  even: {
    backgroundColor: "#9FA8DA",
    opacity: 1.79,
    height: 80
  }
};

const styleConsTable = {
  head: {
    backgroundColor: "#F44336",
    opacity: 1.79,
    color: "#FFEBEE",
    fontWeight: "bold",
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center"
  },
  odd: {
    backgroundColor: "#EF9A9A",
    opacity: 1.79,
    height: 80
  },
  even: {
    backgroundColor: "#E57373",
    opacity: 1.79,
    height: 80
  }
};

const tcStyle = {
  paddingLeft: 10,
  paddingRight: 10,
  textAlign: "center"
};

const makeProsTBody = (v, i) => (
  <Tr
    key={`pros-${i}`}
    style={i % 2 === 0 ? styleProsTable.even : styleProsTable.odd}
  >
    <Tc style={tcStyle}>{`${i + 1}位`}</Tc>
    <Tc style={tcStyle}>{v.number}</Tc>
    <Tc style={{ ...tcStyle, textAlign: "left" }}>{v.item}</Tc>
    <Tc style={tcStyle}>{toFixed(v.point, 1)}pt</Tc>
  </Tr>
);

const makeConsTBody = (v, i) => (
  <Tr
    key={`cons-${i}`}
    style={i % 2 === 0 ? styleConsTable.even : styleConsTable.odd}
  >
    <Tc style={tcStyle}>{`${63 - i}位`}</Tc>
    <Tc style={tcStyle}>{v.number}</Tc>
    <Tc style={{ ...tcStyle, textAlign: "left" }}>{v.item}</Tc>
    <Tc style={tcStyle}>{toFixed(v.point, 1)}pt</Tc>
  </Tr>
);

const QuestionRanking = props => (
  <Fragment>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ width: "49%" }}>
        <h3 style={{ textAlign: "center" }}>肯定的な質問トップ10</h3>
        <Paper>
          <Table>
            <Thead>
              <Tr>
                <Tc style={{ ...styleProsTable.head, width: 35 }}>順位</Tc>
                <Tc style={{ ...styleProsTable.head, width: 35 }}>番号</Tc>
                <Tc style={styleProsTable.head}>質問項目</Tc>
                <Tc style={{ ...styleProsTable.head, width: 55 }}>点数</Tc>
              </Tr>
            </Thead>
            <TBody>{props.prosData.map((v, i) => makeProsTBody(v, i))}</TBody>
          </Table>
        </Paper>
      </div>
      <div style={{ width: "49%" }}>
        <h3 style={{ textAlign: "center" }}>否定的な質問トップ10</h3>
        <Paper>
          <Table>
            <Thead>
              <Tr>
                <Tc style={{ ...styleConsTable.head, width: 35 }}>順位</Tc>
                <Tc style={{ ...styleConsTable.head, width: 35 }}>番号</Tc>
                <Tc style={styleConsTable.head}>質問項目</Tc>
                <Tc style={{ ...styleConsTable.head, width: 55 }}>点数</Tc>
              </Tr>
            </Thead>
            <TBody>{props.consData.map((v, i) => makeConsTBody(v, i))}</TBody>
          </Table>
        </Paper>
      </div>
    </div>
  </Fragment>
);

QuestionRanking.propTypes = {
  prosData: PropTypes.arrayOf(PropTypes.object).isRequired,
  consData: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default QuestionRanking;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/QuestionRanking.jsx